import { render, staticRenderFns } from "./Loads.vue?vue&type=template&id=51029491"
import script from "./Loads.vue?vue&type=script&lang=js"
export * from "./Loads.vue?vue&type=script&lang=js"
import style0 from "./Loads.vue?vue&type=style&index=0&id=51029491&prod&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports